import { render, staticRenderFns } from "./B-3-2-3__BUPageEdit_Sec-ProductCategory.vue?vue&type=template&id=1641cd3c&"
import script from "./B-3-2-3__BUPageEdit_Sec-ProductCategory.vue?vue&type=script&lang=js&"
export * from "./B-3-2-3__BUPageEdit_Sec-ProductCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports